<script>

import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import datetime from "@/mixins/datetime";
import workHistory from "@/mixins/daily_reports/workHistory";

export default {
  name: "ModalWorkHistory",
  mixins: [tableSearch, datetime, workHistory],
  components: {
    CommonTableComponent
  },
}
</script>

<template>
  <div class="d-xl-flex">
    <b-modal
      title="作業履歴"
      size="xl"
      id="modal-work-history"
      centered
      title-class="font-18"
      hide-footer
      scrollable
      @show="getData"
    >
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <div>
            <div class="mb-3">
              <div>
                <span>作業指示番号：</span>
                <span id="workOrderId" class="mr-4">{{ workOrderId }}</span>
                <span>作業指示名：</span>
                <span id="workOrderName">{{ workOrderName }}</span>
              </div>
            </div>

            <CommonTableComponent :height-class="`table-wrapper-500`">
              <thead class="table-light">
              <tr>
                <th
                  v-for="(item, index) in headers"
                  :key="index"
                  :class="getHeaderClass(item)"
                >
                <span v-if="item.sortable" @click="clickSort(item.value)">
                  {{ item.text }}
                  <i :class="getSortClass(item.value)"></i>
                </span>
                  <span v-else>
                  {{ item.text }}
                </span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in data">
                <td>{{ item.start_datetime }}</td>
                <td>{{ getUserName(item) }}</td>
                <td>{{ item.remarks }}</td>
              </tr>
              <tr v-if="!data.length">
                <td colspan="13" class="text-center">
                  データなし。
                </td>
              </tr>
              </tbody>
            </CommonTableComponent>
          </div>

        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>

<style scoped>

</style>
